/* NOOKS Home Product Feature — behaviour (Header Relaunch build)
   1. Ticker: clone the run once so translateX(-50%) loops seamlessly
   2. Gallery: thumbs swap the main frame (image or looping texture video)
   3. Bundle rows: radiogroup; CTA label, proof line follow the selection (single variant, qty 1/2/3)
   4. Add to cart: POST /cart/add.js with the selected quantity, then open the NOOKS header cart drawer
   5. Klaviyo: live review count into the ticker when available (metafields render server-side as the baseline)
   Wallet is Shopify's native {{ form | payment_button }}; its qty is synced by the section's pf:select handler. */
(function () {
  const S = document.getElementById('nk-pf');
  if (!S) return;
  const $ = s => S.querySelector(s), $$ = s => S.querySelectorAll(s);

  /* 1. ticker — continuous marquee.
     Repeat the run enough times that the track is always >= 2x the container, then
     translate by exactly ONE original run-width in px so the loop is seamless at any width. */
  const track = $('[data-pf-ticker]'), run = $('[data-pf-run]');
  function buildTicker() {
    if (!track || !run) return;
    // reset to a single run before (re)building (handles resize)
    track.querySelectorAll('[data-pf-run]').forEach((r, i) => { if (i > 0) r.remove(); });
    const runWidth = run.getBoundingClientRect().width;
    if (!runWidth) return;
    const container = (S.querySelector('.pf-ticker') || track.parentElement).getBoundingClientRect().width || runWidth;
    // copies needed so the strip is always >= 2x the container (min 2 for the loop)
    const copies = Math.max(2, Math.ceil((container * 2) / runWidth) + 1);
    for (let i = 1; i < copies; i++) { const c = run.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); }
    track.style.setProperty('--pf-ticker-shift', runWidth + 'px');
    // keep a constant scroll speed (~55px/s) regardless of run width so it doesn't gallop on wide screens
    track.style.setProperty('--pf-ticker', (runWidth / 55).toFixed(1) + 's');
  }
  buildTicker();
  // rebuild on resize (debounced) so it stays gap-free across breakpoints
  let tkT; addEventListener('resize', () => { clearTimeout(tkT); tkT = setTimeout(buildTicker, 200); });

  /* 2. gallery */
  const mainImg = $('[data-pf-main-img]'), mainVid = $('[data-pf-main-vid]');
  // SCOUT 2026-09-09: the texture MP4 is heavy and MOST shoppers never tap TEXTURE. Load it
  // ONLY on the first TEXTURE tap (poster covers the frame until then), instead of letting a
  // global 300px-margin IntersectionObserver download it as the section nears the viewport.
  function ensureVideoSrc(v) {
    if (!v) return;
    if (!v.getAttribute('src') && v.dataset.nkLazySrc) {
      v.setAttribute('src', v.dataset.nkLazySrc);
      v.preload = 'auto';
      try { v.load(); } catch (e) {}
    }
  }
  $$('[data-pf-thumb]').forEach(t => t.addEventListener('click', () => {
    $$('[data-pf-thumb]').forEach(x => { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
    t.classList.add('is-active'); t.setAttribute('aria-selected', 'true');
    const vid = t.dataset.video === 'true';
    if (mainImg) mainImg.hidden = vid;
    if (mainVid) mainVid.hidden = !vid;
    if (!vid) { if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = t.dataset.src; } }
    else if (mainVid) { ensureVideoSrc(mainVid); mainVid.play().catch(() => {}); }
    // Also load the tiny thumbnail preview video the first time TEXTURE is chosen.
    var thumbVid = t.querySelector('video');
    if (thumbVid) ensureVideoSrc(thumbVid);
  }));

  /* 3. bundle rows */
  const saves = { 1: 'FREE AU SHIPPING FROM TWO TINS', 2: 'YOU SAVE $4.95 + FREE AU SHIPPING', 3: 'YOU SAVE $14.90 + FREE AU SHIPPING' };
  const add = $('[data-pf-add]'), save = $('[data-pf-save]');
  let current = $('[data-pf-row][aria-checked="true"]') || $('[data-pf-row]');
  function totalFor(row) {
    // Prefer the section's designed price strings (data-price-N on the section), fall back to the row's data-total.
    const q = +row.dataset.qty;
    const p = S.dataset['price' + q];
    return p || row.dataset.total || '';
  }
  function select(row) {
    if (!row) return;
    $$('[data-pf-row]').forEach(r => r.setAttribute('aria-checked', r === row ? 'true' : 'false'));
    current = row;
    const q = +row.dataset.qty;
    const total = totalFor(row);
    if (add) add.textContent = 'Add ' + q + (q === 1 ? ' tin' : ' tins') + ' to cart · ' + total;
    if (save) save.textContent = saves[q] || saves[1];
    S.dispatchEvent(new CustomEvent('pf:select', { bubbles: true, detail: { qty: q, variantId: row.dataset.variantId } }));
  }
  $$('[data-pf-row]').forEach(r => {
    r.addEventListener('click', () => select(r));
    r.addEventListener('keydown', e => {
      const rows = [...$$('[data-pf-row]')], i = rows.indexOf(r);
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); const n = rows[(i + 1) % rows.length]; n.focus(); select(n); }
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); const n = rows[(i - 1 + rows.length) % rows.length]; n.focus(); select(n); }
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(r); }
    });
  });
  select(current);

  /* 4. add to cart — route through the ONE canonical path (window.nooksAddToCart) so behaviour
     is identical everywhere: optimistic label, double-add lock, bundled-section drawer render in
     a single /cart/add round-trip, and NEVER a page nav on the happy path. (Scout 2026-09-09) */
  if (add) add.addEventListener('click', async () => {
    const id = current && current.dataset.variantId;
    const qty = current ? +current.dataset.qty : 1;
    if (!id || !/^\d+$/.test(id)) { add.textContent = 'Added (demo)'; setTimeout(() => select(current), 1200); return; }
    const label = add.textContent;
    if (typeof window.nooksAddToCart === 'function') {
      await window.nooksAddToCart(+id, qty, add, {
        addingLabel: 'Adding\u2026',
        onDone: function(){ document.dispatchEvent(new CustomEvent('pf:added', { detail: { variantId: id, quantity: qty } })); select(current); },
        onFail: function(){ select(current); }
      });
      // canonical helper restores the button; make sure the correct dynamic label returns.
      setTimeout(function(){ select(current); }, 1300);
      return;
    }
    // Fallback (helper somehow absent): minimal single add + open, still no forced nav on success.
    add.disabled = true;
    add.textContent = 'Adding\u2026';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +id, quantity: qty }] })
      });
      document.dispatchEvent(new CustomEvent('pf:added', { detail: { variantId: id, quantity: qty } }));
      const h = document.querySelector('[data-nk-open="cart"]'); if (h) h.click();
    } catch (e) { /* no forced nav */ }
    finally { add.disabled = false; select(current); }
  });

  /* 5. Klaviyo reviews aggregate (optional live upgrade; server-rendered metafields are the baseline) */
  if (window.klaviyoReviews && typeof window.klaviyoReviews.getAggregate === 'function') {
    Promise.resolve(window.klaviyoReviews.getAggregate(S.dataset.productHandle)).then(r => {
      if (r && r.count) $$('[data-pf-review-count]').forEach(e => e.textContent = r.count);
    }).catch(() => {});
  }
})();

